import useSWR from 'swr'
import { guardClient } from '../_axios'

/**
 * 選択した会社情報のメモを取得
 * [get]/memo/:companyId
 */
type DataType = {
  id: number
  version: string
  name: string
  memo: string
}
type Response = { data: DataType }

const selectMemoFetcher = (urlTail: string) => {
  const response = guardClient.get<Response>(urlTail).then((r) => r.data)
  return response
}
export const useSelectMemo = (companyId: number) => {
  const path = `/memo/${companyId}`

  const { data, mutate } = useSWR(path, selectMemoFetcher, {
    onErrorRetry: () => {
      return
    }
  })
  return { data: data?.data, mutate }
}
